import { render, staticRenderFns } from "./ProductCategorySelector.vue?vue&type=template&id=0849c6e1"
import script from "./ProductCategorySelector.vue?vue&type=script&lang=js"
export * from "./ProductCategorySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports